// Silent per-account sync helpers for personal progress (checklists, counters, adhkar).
// All calls are best-effort: failures (offline / signed-out) are swallowed so the
// device's localStorage copy remains the source of truth until the next successful sync.
import api from "@/lib/api";

export const getLearn = () => api.get("/learn").then((r) => r.data).catch(() => null);

export const putLearn = (partial) => api.put("/learn", partial).catch(() => {});
